import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import backgroundImg from '../../assets/screens/screen-confirmation-multiple.png';
import backgroundImgValue from '../../assets/screens/screen-confirmation-multiple-value.png';
import CardReaderScreen from '../../molecules/CardReaderScreen/CardReaderScreen';
import {
  TICKET_TYPE_ADDITIONAL_ZONE,
  TICKET_TYPE_VALUE_TICKET,
} from '../../constants';
import ConfirmationScreenContent from '../../molecules/ConfirmationScreenContent/ConfirmationScreenContent';
import {
  getTicketExpirationStringForZones,
  getDateString15DaysFromNow,
} from '../../time';
import { getTicketPrice } from '../../price';
import { getAdditionalZones, getCombinedZones } from '../../zones';

class AdditionalZoneConfirmationRC extends PureComponent {
  render() {
    const {
      currentZone,
      zones,
      seasonalTicketZones,
      passengers,
      remainingFunds,
    } = this.props;
    const additionalZones = getAdditionalZones(zones, seasonalTicketZones);
    const combinedZones = getCombinedZones(
      additionalZones,
      seasonalTicketZones,
    );
    const extraPassengers = passengers - 1;
    const hasExtraPassengers = extraPassengers > 0;

    const additionalZoneTicket = {
      additionalZones,
      validityEndsAtString: getTicketExpirationStringForZones(combinedZones),
    };

    const seasonalTicket = {
      zones: seasonalTicketZones,
      validityEndsAtString: getDateString15DaysFromNow(),
    };

    const valueTicket = hasExtraPassengers /* eslint-disable indent */
      ? {
          zones,
          passengers: extraPassengers,
          price: getTicketPrice(TICKET_TYPE_VALUE_TICKET, zones),
          validityEndsAtString: getTicketExpirationStringForZones(zones),
        }
      : null;
    return (
      <CardReaderScreen
        backgroundImage={
          hasExtraPassengers ? backgroundImgValue : backgroundImg
        }
      >
        <ConfirmationScreenContent
          currentZone={currentZone}
          ticketType={TICKET_TYPE_ADDITIONAL_ZONE}
          additionalZoneTicket={additionalZoneTicket}
          seasonalTicket={seasonalTicket}
          valueTicket={valueTicket}
          remainingFunds={remainingFunds}
        />
      </CardReaderScreen>
    );
  }
}

AdditionalZoneConfirmationRC.propTypes = {
  currentZone: PropTypes.string.isRequired,
  zones: PropTypes.string.isRequired,
  seasonalTicketZones: PropTypes.string.isRequired,
  passengers: PropTypes.number.isRequired,
  remainingFunds: PropTypes.number.isRequired,
};

const mapStateToProps = ({ cardReader }) => ({
  currentZone: cardReader.currentZone,
  zones: cardReader.additionalZoneTicket.zones,
  seasonalTicketZones: cardReader.additionalZoneTicket.seasonalTicketZones,
  passengers: cardReader.additionalZoneTicket.passengers,
  remainingFunds: cardReader.remainingFunds,
});

export default connect(mapStateToProps)(AdditionalZoneConfirmationRC);
